import React, {useContext, useEffect, useState} from 'react'
import {DatePicker} from 'antd'
import {SyncOutlined} from "@ant-design/icons"
import moment from "moment"
import SettingShippingRuleContext from '../context/RequestUpdateContext'
import {
    forcedUpdate,
    listSource,
    listStatus,
    listProductionStatus,
    listCurrentStatusFAC,
    listCurrentStatus3D,
    productionStatus
} from "../contanst/contanstFilter"
import CustomMultiSelect from "../../../components/CustomMultilSelect/CustomMultiSelect"
import {getListSku} from "../../../services/api/apiSku"
import SelectSearch from "./filters/SelectSearch"
import FilterOptions from "../../../components/InputSelect/FilterOptions"

const {RangePicker} = DatePicker

const RequestUpdateFilters = () => {
    const {filters, setState} = useContext(SettingShippingRuleContext)
    const [skus, setSkus] = useState([{value: '', name: 'Chọn Sku'}])
    const [loadingSku, setLoadingSku] = useState(false)

    const _fetchListSkus = async () => {
        setSkus([])
        setLoadingSku(true)

        try {
            const payload = {
                sort: 'name',
                limit: 10000,
                page: 1,
            }

            const {'data': responsive} = await getListSku(payload)

            const {success, data} = responsive

            if (!success) return setLoadingSku(false)

            const skus = data.items.map(item => {
                return {
                    value: item.sku,
                    name: item.name,
                    id: item._id
                }
            })
            setSkus(skus)
        } catch (e) {
            console.log(e.message)
        }
        setLoadingSku(false)
    }

    const _handleChangeFilterState = (name, value) => {
        const _filters = {
            ...filters,
            [name]: value
        }
        setState(_filters)
    }

    const _handleChangeSuppliers = (paramFilter) => {
        const _filters = {
            ...filters,
            ...paramFilter
        }
        setState(_filters)
    }

    const _onDateChange = (dates) => {
        if (!!dates && dates.length === 2) {
            if (typeof setState === 'function') {
                setState({
                    updated_at: {
                        from: moment(dates[0]).startOf('day'),
                        to: moment(dates[1]).startOf('day')
                    }
                })
            }
        } else {
            const _filters = Object.assign({}, filters)
            delete _filters['updated_at']
            if (typeof setState === 'function') {
                setState(_filters)
            }
        }
    }

    useEffect(() => {
        _fetchListSkus()
    }, [])

    return (
        <div className=" mb-3">
            <div className="d-flex GroupFilter">
                <div className="itemFilter w-100 mb-3">
                    <div className="font-weight-500 LabelFilter mb-1">Skus:</div>
                    <FilterOptions
                        selectedKey={filters.skus || []}
                        field='skus'
                        allowClear={true}
                        placeHolder={loadingSku ? "Loading..." : "Select Skus"}
                        options={skus}
                        defaultOption={[]}
                        layout='select'
                        mode='multiple'
                        onChangeOption={_handleChangeSuppliers}
                    />

                    {
                        loadingSku && <div className="loadingSku"><SyncOutlined spin/></div>
                    }
                </div>
                <div className="itemFilter w-50">
                    <CustomMultiSelect
                        name='current_production_statuses'
                        label={'Trạng thái FAC'}
                        placeholder={'Chọn trạng thái'}
                        selected={filters.current_production_statuses}
                        listFilters={listCurrentStatusFAC}
                        onChangeFilters={_handleChangeFilterState}
                    />
                </div>
                <div className="itemFilter w-50">
                    <CustomMultiSelect
                        name='current_production_statuses_3d'
                        label={'Trạng thái 3D'}
                        placeholder={'Chọn trạng thái'}
                        selected={filters.current_production_statuses_3d}
                        listFilters={listCurrentStatus3D}
                        onChangeFilters={_handleChangeFilterState}
                    />
                </div>
                <div className="itemFilter w-50">
                    <SelectSearch
                        name="production_status_changed"
                        value={filters.production_status_changed || ''}
                        label="Đã sản xuất:"
                        listSelect={productionStatus}
                        onChange={_handleChangeFilterState}
                    />
                </div>
            </div>
            <div className="d-flex GroupFilter">
                <div className="itemFilter w-100">
                    <CustomMultiSelect
                        name='progress_statuses'
                        label={'Trạng thái request'}
                        placeholder={'Chọn trạng thái'}
                        selected={filters.progress_statuses}
                        listFilters={listStatus}
                        onChangeFilters={_handleChangeFilterState}
                    />
                </div>
                <div className="itemFilter w-100">
                    <CustomMultiSelect
                        name='production_status'
                        label={'Trạng thái đơn'}
                        placeholder={'Chọn trạng thái'}
                        selected={filters.production_status}
                        listFilters={listProductionStatus}
                        onChangeFilters={_handleChangeFilterState}
                    />
                </div>
                <div className="itemFilter w-100">
                    <SelectSearch
                        name="force_update"
                        value={filters.force_update || ''}
                        label="Forced update:"
                        listSelect={forcedUpdate}
                        onChange={_handleChangeFilterState}
                    />
                </div>
                <div className="itemFilter w-100">
                    <CustomMultiSelect
                        name='sources'
                        label={'Source'}
                        placeholder={'Chọn source'}
                        selected={filters.sources}
                        listFilters={listSource}
                        onChangeFilters={_handleChangeFilterState}
                    />
                </div>
                <div className="itemFilter SearchDateTime w-100">
                    <label className="font-weight-500 LabelFilter mb-1">Ngày update</label>
                    <div className='DatePicker'>
                        <RangePicker
                            placeholder={['Updated start', 'Updated end']}
                            format="DD/MM/YYYY"
                            onChange={_onDateChange}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RequestUpdateFilters
